<template>
  <div id="app">
    <router-view/>
    <global-loading></global-loading>
  </div>
</template>

<script>
import globalLoading from '@/components/global/loading'
export default {
  name: 'App',
  components: {globalLoading}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue